import QTable from 'quasar/src/components/table/QTable.js';

export const getContentCampaignColumnsInAdmin = (): QTable['columns'] => [
  {
    name: 'id',
    field: 'id',
    label: 'شماره کمپین',
    align: 'left'
  },
  {
    name: 'title',
    field: 'title',
    label: 'عنوان کمپین',
    align: 'left',
    style: 'max-width: 200px',
    classes: 'link-tes-navy-blue-darker'
  },
  {
    name: 'items_count',
    field: 'items_count',
    label: 'تعداد',
    align: 'left'
  },
  {
    name: 'status',
    field: 'status',
    label: 'وضعیت',
    align: 'left'
  },
  {
    name: 'user',
    field: 'user',
    label: 'نام کاربر',
    align: 'center',
    style: 'max-width: 120px'
  },
  {
    name: 'username',
    field: 'username',
    label: 'نام کاربری',
    align: 'center',
  },
  {
    name: 'running_at',
    field: 'running_at',
    label: 'تاریخ ثبت',
    align: 'left'
  },
  {
    name: 'actions',
    field: 'actions',
    label: '',
    align: 'left'
  }
]

export function getContentCampaignColumns(q): QTable['columns'] {
  let columns = [
    {
      name: 'id',
      label: 'شماره کمپین',
      field: 'id',
      align: 'left',
      headerStyle: 'max-width:100px',
      style: 'max-width:100px'
    },
    {
      name: 'title',
      label: 'عنوان کمپین',
      field: 'title',
      align: 'left',
      style: 'max-width:250px;min-width:150px'
    },
    {
      name: 'status',
      label: 'وضعیت',
      field: 'status',
      align: 'center'
    },
    {
      name: 'actions',
      label: '',
      field: 'actions',
      align: 'left'
    }
  ]

  columns.splice(q.screen.lt.md ? 4 : 2, 0, {
    name: 'items_count',
    label: 'تعداد مقالات',
    field: 'items_count',
    align: 'left',
    style: 'max-width:200px'
  })

  return columns

}

